<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-tabs :value="activeTab" @tab-click="handleTabChange">
        <el-tab-pane v-for="tab in visibleTabs" :key="tab.name" :label="tab.label" :name="tab.name"></el-tab-pane>
      </el-tabs>
      <div class="page-actions">
        <el-select v-model="nowCoin" placeholder="请选择币种" clearable size="mini">
          <!-- <el-option label="所有币种" value=""></el-option> -->
          <el-option v-for="coin in allCoins" :label="coin" :value="coin" :key="coin"></el-option>
        </el-select>
        <el-select v-model="nowChain" placeholder="请筛选币种链" clearable size="mini">
          <!-- <el-option label="所有币种" value=""></el-option> -->
          <el-option v-for="coin in chainsOptions" :label="coin" :value="coin" :key="coin"></el-option>
        </el-select>
        <el-select v-model="queryType" placeholder="请选择用户类型" size="mini">
          <el-option v-for="item in queryTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="txType" placeholder="请选择提现类型" size="mini">
          <el-option v-for="item in txTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input placeholder="请输入内容" v-model="queryValue" clearable size="mini"></el-input>
        <el-input placeholder="请输入邮箱" v-model="email" clearable size="mini"></el-input>
        <!-- <el-input placeholder="请输入邮箱" v-model="email" clearable></el-input> -->
        <el-input placeholder="请输入订单号" v-model="id" clearable size="mini"></el-input>
        <el-input placeholder="请输入提现地址" v-model="walletAddres" clearable size="mini">
        </el-input>
        <el-input placeholder="hash" v-model="hashCode" size="mini"> </el-input>
        <el-date-picker v-model="times" type="daterange" format="yyyy 年 MM 月 dd 日" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" size="mini">
        </el-date-picker>
        <el-select v-model="mark" placeholder="请筛选异常账户" clearable size="mini">
          <!-- <el-option>全部</el-option> -->
          <el-option v-for="item in ifMark" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

        <el-button @click="handleSearch" type="primary" size="mini">搜索</el-button>

        <el-button size="mini" type="success" v-if="activeTab == '1'" @click="handleBatchAudit">批量审核</el-button>
        <el-button @click="exportData" size="mini">导出Excel</el-button>
        <!-- <a :href="downloadLink"  target="_blank">导出Excel</a> -->
      </div>
      <AuditList ref="auditList" @refresh="getList" :activeTab="activeTab" />
    </el-card>
    <el-dialog title="批量审核" class="batch-review-dialog" :visible.sync="batchReviewVisible" width="960px" top="6vh"
      append-to-body :before-close="handleBatchReviewClose" @opened="onBatchReviewDialogOpened">
      <p class="batch-review-hint">
        对下方已选订单批量执行同一种审批结果；需保持有效谷歌验证会话。
      </p>
      <el-table ref="batchReviewTable" row-key="id" :data="batchReviewTableRows" max-height="360" size="mini" border
        stripe :row-class-name="batchReviewRowClassName" @selection-change="onBatchReviewSelectionChange">
        <el-table-column type="selection" width="48" align="center">
        </el-table-column>
        <el-table-column prop="userId" label="用户ID" width="92">
        </el-table-column>
        <el-table-column prop="id" label="订单号" width="120">
        </el-table-column>
        <el-table-column label="时间" width="148">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
        <el-table-column prop="txCoin" label="币种" width="80">
        </el-table-column>
        <el-table-column prop="chain" label="币种链" width="90">
        </el-table-column>
        <el-table-column prop="txAmount" label="提现数量" width="110">
        </el-table-column>
        <el-table-column label="提现地址" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.txToWallet }}
          </template>
        </el-table-column>
        <el-table-column label="是否异常账号" width="118" align="center">
          <template slot-scope="scope">
            <span :class="{ red: scope.row.mark }">{{
              scope.row.mark ? "是" : "否"
            }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-form ref="batchReviewFormRef" class="batch-review-form" :model="batchReviewForm" :rules="batchReviewRules"
        label-width="100px">
        <el-form-item label="审批意见" prop="remark">
          <el-input type="textarea" :rows="3" v-model="batchReviewForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="审批结果" prop="decision">
          <el-select v-model="batchReviewForm.decision" @change="onBatchReviewDecisionChange" style="width: 100%">
            <el-option label="审批通过" value="APPROVE"></el-option>
            <el-option label="审批拒绝" value="REJECT"></el-option>
            <el-option label="置为异常" value="ABNORMAL"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchReviewVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmBatchReviewSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "./store";
import AuditList from "./components/list";
import qs from "qs";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "WithdrawalAudit",
  data() {
    return {
      tabs: [
        { label: "已提交", name: "1", perm: "tenant:audit_withdrawal:tab_1" },
        { label: "已审核", name: "4", perm: "tenant:audit_withdrawal:tab_4" },
        {
          label: "区块链网络已经发送，等待确认中",
          name: "5",
          perm: "tenant:audit_withdrawal:tab_5",
        },
        { label: "提现成功", name: "0", perm: "tenant:audit_withdrawal:tab_0" },
        { label: "失败", name: "-1", perm: "tenant:audit_withdrawal:tab_-1" },
        { label: "已取消", name: "2", perm: "tenant:audit_withdrawal:tab_2" },
        { label: "系统异常", name: "6", perm: "tenant:audit_withdrawal:tab_6" },
        { label: "管理员撤销", name: "7", perm: "tenant:audit_withdrawal:tab_7" },
      ],
      txType: '',
      txTypeList: [
        { value: -1, label: '提现' },
        { value: -2, label: '内部转出' }
      ],
      batchReviewVisible: false,
      /** 批量弹窗内表格数据（与列表勾选快照，可在弹窗内再取消部分） */
      batchReviewTableRows: [],
      /** 批量弹窗内当前仍勾选的行 */
      batchReviewSelection: [],
      batchReviewForm: {
        remark: "",
        decision: "APPROVE",
      },
      times: [],
      // startTime:'',
      // endTime:'',
      // chainsOptions:[],
      id: "",
      email: "",
      phone: "",
      nowChain: "",
      nowCoin: "",
      walletAddres: "",
      queryValue: "",
      queryType: "",
      hashCode: "",
      mark: null,
      queryTypeList: [
        {
          value: "0",
          label: "用户ID",
        },
        {
          value: "1",
          label: "用户账号",
        },
      ],
      ifMark: [
        { value: true, label: "异常账户" },
        { value: false, label: "非异常账户" },
      ],
    };
  },
  components: {
    AuditList,
  },
  computed: {
    ...mapState("withdrawalAudit", [
      "activeTab",
      "allCoins",
      "pagination",
      "chainsData",
      "idStr",
      "selectedWithdrawRows",
    ]),
    chainsOptions() {
      return [...new Set([...this.chainsData, ...this.allCoins])];
    },
    visibleTabs() {
      return this.tabs.filter((tab) => this.$hasPerm(tab.perm));
    },
    batchReviewRules() {
      return {
        decision: [
          { required: true, message: "请选择审批结果", trigger: "change" },
        ],
        remark: [
          {
            validator: (rule, value, callback) => {
              const d = this.batchReviewForm.decision;
              if (
                (d === "REJECT" || d === "ABNORMAL") &&
                (!value || !String(value).trim())
              ) {
                callback(new Error("请填写审批意见"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      };
    },

    startTime() {
      return this.times ? this.times[0] : "";
    },
    endTime() {
      if (!this.times || !this.times[1]) {
        return "";
      }
      const end = new Date(this.times[1]);
      end.setHours(23, 59, 59, 999);
      return end.getTime();
    },
    downloadLink() {
      const data = {
        txStatus: this.activeTab,
        nowCoin: this.nowCoin,
        walletAddres: this.walletAddres,
        queryValue: this.queryValue,
        queryType: this.queryType,
        startTime: this.startTime,
        endTime: this.endTime,
        hashCode: this.hashCode,
        txType: this.txType,
        status: 1,
        ...this.pagination,
      };
      const params = qs.stringify(data);
      return `/ta/admin/workorder/search_withdraw?${params}`;
    },
  },
  methods: {
    ...mapMutations("withdrawalAudit", [
      "changeTab",
      "resetWithdrawalBatchPick",
    ]),
    ...mapActions("withdrawalAudit", [
      "list",
      "listCoinType",
      "listBillType",
      "getAllCoins",
      "changeCoinType",
      "getChains",
      "getExcelData",
      "submitWithdrawReviewList",
    ]),
    hasTabPerm(tabName) {
      const tab = this.tabs.find((item) => item.name === tabName);
      return !!(tab && this.$hasPerm(tab.perm));
    },
    ensureValidTab() {
      if (this.hasTabPerm(this.activeTab)) {
        return this.activeTab;
      }
      const firstTab = this.visibleTabs[0];
      const nextTab = firstTab ? firstTab.name : "";
      if (nextTab !== this.activeTab) {
        this.changeTab(nextTab);
      }
      return nextTab;
    },
    exportData() {
      const currentTab = this.ensureValidTab();
      if (!currentTab) {
        return;
      }
      const listRef = this.$refs.auditList;
      if (!listRef || !listRef.ensureWithdrawGoogleSession) {
        this.$message.warning("请稍后重试");
        return;
      }
      listRef.ensureWithdrawGoogleSession().then((ok) => {
        if (!ok) return;
        const data = this.buildFilterParams(currentTab);
        const params = qs.stringify(data);
        this.getExcelData(params).then((res) => {
          const link = document.createElement("a");
          const blob = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }); //设置文件流
          link.style.display = "none";
          // 设置连接
          link.href = URL.createObjectURL(blob); //将文件流转化为blob地址
          console.log("link-href", link.href);
          link.download = "提现审批统计报表.xlsx";
          document.body.appendChild(link);
          // 模拟点击事件
          link.click(); //设置点击事件
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
        });
      });
    },

    buildFilterParams(txStatus = this.activeTab) {
      return {
        chain: this.nowChain,
        userId: this.userId,
        txStatus,
        coinType: this.nowCoin,
        walletAddres: this.walletAddres,
        queryValue: this.queryValue,
        email: this.email,
        phone: this.phone,
        id: this.id,
        queryType: this.queryType,
        hashCode: this.hashCode,
        mark: this.mark,
        startTime: this.startTime,
        endTime: this.endTime,
        txType: this.txType,
      };
    },

    handleTabChange(tab) {
      if (!this.hasTabPerm(tab.name)) {
        return;
      }
      if (this.activeTab === "1" && tab.name !== "1") {
        this.resetWithdrawalBatchPick();
        this.$nextTick(() => {
          if (this.$refs.auditList) this.$refs.auditList.clearAuditSelection();
        });
      }
      this.changeTab(tab.name);
      this.getList({
        page: 1,
      });
    },
    getList(data = {}) {
      const currentTab = this.ensureValidTab();
      if (!currentTab) {
        return;
      }
      this.list({
        ...this.buildFilterParams(currentTab),
        ...this.pagination,
        ...data,
      });
    },
    onBatchReviewDialogOpened() {
      this.$nextTick(() => {
        const t = this.$refs.batchReviewTable;
        if (!t || !this.batchReviewTableRows.length) {
          this.batchReviewSelection = [];
          return;
        }
        t.clearSelection();
        this.batchReviewTableRows.forEach((row) => {
          t.toggleRowSelection(row, true);
        });
        this.batchReviewSelection = this.batchReviewTableRows.slice();
      });
    },
    onBatchReviewSelectionChange(val) {
      this.batchReviewSelection = val || [];
    },
    batchReviewRowClassName({ row }) {
      return row.mark ? "withdraw-batch-row-risk" : "";
    },
    onBatchReviewDecisionChange() {
      this.$nextTick(() => {
        if (this.$refs.batchReviewFormRef) {
          this.$refs.batchReviewFormRef.clearValidate("remark");
        }
      });
    },
    handleBatchReviewClose(done) {
      this.$confirm("确认关闭？")
        .then(() => done())
        .catch(() => { });
    },
    //批量审核
    handleBatchAudit() {
      const listRef = this.$refs.auditList;
      const rows = this.selectedWithdrawRows || [];
      if (!rows.length) {
        this.$message.warning("请先至少勾选一条提现记录");
        return;
      }
      if (!listRef) {
        this.$message.warning("请稍后重试");
        return;
      }
      if (rows.length === 1) {
        listRef.startWithdrawReview(rows[0]);
        return;
      }
      listRef.ensureWithdrawGoogleSession().then((ok) => {
        if (!ok) return;
        this.batchReviewTableRows = (this.selectedWithdrawRows || []).slice();
        this.batchReviewSelection = [];
        this.batchReviewForm = { remark: "", decision: "APPROVE" };
        this.batchReviewVisible = true;
        this.$nextTick(() => {
          if (this.$refs.batchReviewFormRef) {
            this.$refs.batchReviewFormRef.clearValidate();
          }
        });
      });
    },
    confirmBatchReviewSubmit() {
      const listRef = this.$refs.auditList;
      if (!listRef || !listRef.withGoogleSessionRetry) {
        this.$message.warning("请稍后重试");
        return;
      }
      this.$refs.batchReviewFormRef.validate((valid) => {
        if (!valid) return;
        const rows = this.batchReviewSelection || [];
        if (!rows.length) {
          this.$message.warning("请至少勾选一条订单（可在表格中取消不需要审核的行）");
          return;
        }
        const id = rows.map((r) => r.id).join(",");
        listRef
          .withGoogleSessionRetry(() =>
            this.submitWithdrawReviewList({
              id,
              decision: this.batchReviewForm.decision,
              remark: this.batchReviewForm.remark,
            })
          )
          .then((res) => {
            if (!res || res.code === 9401) {
              return;
            }
            if (res.code === 0) {
              this.$message.success("操作成功");
            } else if (res.msg) {
              this.$message.warning(res.msg);
            }
            this.batchReviewVisible = false;
            listRef.clearAuditSelection();
            this.resetWithdrawalBatchPick();
            this.handleSearch();
          });
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
      });
    },
  },
  watch: {
    nowCoin(val) {
      this.changeCoinType(val);
      this.getList({
        page: 1,
      });
    },
    visibleTabs() {
      this.ensureValidTab();
    },
  },
  mounted() {
    this.ensureValidTab();
    this.getAllCoins();
    this.getList();
    this.getChains();
  },
};
</script>

<style lang="less">
.user-withdrawal-link {
  color: #409eff;

  .cell {
    span {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.user-withdrawal-records-wrap {
  .el-table {
    .cell {
      font-size: 12px;
      text-align: center;
    }
  }

  .user-withdrawal-pager-wrap {
    text-align: right;
    margin: 10px 0px;
  }
}

.batch-review-hint {
  margin: 0 0 12px;
  font-size: 13px;
  color: #606266;
}

.batch-review-form {
  margin-top: 16px;
}

.batch-review-dialog .red,
.red {
  color: red;
  font-weight: bold;
}

.batch-review-dialog .el-table tbody tr.withdraw-batch-row-risk>td {
  background-color: #fef0f0 !important;
}
</style>
